import styled from 'styled-components';
import { theme } from '../layout/theme';

interface Iwrapper {
  fullwidth?: boolean;
  TopPadding?: boolean;
  border?: boolean;
}

export const Wrapper = styled.div<Iwrapper>`
  z-index: ${theme.layers.backdrop};
  max-width: 1400px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  padding: 16px;
  position: fixed;
  bottom: 20vh;
  width: ${(props) => (props.fullwidth ? '100%' : '80vw')};
  animation: shimmyM 0.5s;
  @keyframes shimmyM {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(-0%);
    }
  }
  ${theme.screens.Md} {
    border-radius: 10px;
    top: 50%;
    left: 50%;
    height: fit-content;
    transform: translateX(-50%) translateY(-50%);
    width: ${(props: Iwrapper) => (props.fullwidth ? '80vw' : '27rem')};

    animation: shimmy 0.5s;
    @keyframes shimmy {
      0% {
        transform: translateX(-50%) translateY(100%);
      }
      100% {
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }
`;

export const Header = styled.div<Iwrapper>`
  font-size: 1.25rem;
  border-bottom: ${(props) => (props.border ? 'unset' : '3px solid #eee')};
  padding-bottom: 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const CloseIconWrapper = styled.div`
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const Content = styled.div<Iwrapper>`
  font-size: 1rem;
  padding: ${(props) => (props.TopPadding ? '0px 0 13px 0' : '18px 0 13px 0')};
`;
export const Footer = styled.div`
  font-size: 1rem;
`;
export const TitlteWrapper = styled.div`
  display: flex;
  justify-content: start;
`;
